var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-avatar--wrapper",style:([_vm.style, _vm.customStyle]),attrs:{"aria-hidden":"true"}},[_vm._t("default",[_vm._v(_vm._s(_vm.userInitial))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }